<template>
  <div class="page">
    <div class="page__title">
      {{ getModuleConfig("store_picker_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('store_picker_page.form_desc')"
    ></div>
    <div  class="page__content" v-if="getModuleConfig('branch_picker_page.content')" v-html="getModuleConfig('branch_picker_page.content')"></div>
    <div class="col-12 px-2" v-for="(option, idx) in options" :key="idx">
    <SharedRadio
        v-model="channel"
        :id="`proxy-${idx}`"
        :value="option.value"
        name="proxy"
    >
        {{ option.text }}
    </SharedRadio>
    </div>
    <div
      v-if="
        getModuleConfig('store_picker_page.button_text') ||
        getModuleConfig('store_picker_page.cancel_button_text')
      "
      class="p-3 fixed-bottom bg-white footer"
    >
      <SharedButton class="s-btn-bg-primary mb-2" @click="bindStore" :disabled="!channel || showLoading">{{
        getModuleConfig("store_picker_page.button_text")
      }}</SharedButton>

      <MemberButton
        :button-style='`s-btn-outline-primary`'
        :button-text="getModuleConfig('store_picker_page.cancel_button_text')"
        :button-url="getModuleConfig('store_picker_page.cancel_button_url')"
        :type="getModuleConfig('store_picker_page.cancel_button_action')"
        :disabled="showLoading"
      ></MemberButton>

      <!-- <SharedButton variant="outline-dark" class="s-btn-outline-primary">{{
        getModuleConfig("store_picker_page.cancel_button_text")
      }}</SharedButton> -->
    </div>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import branchMixin from "@/mixins/liff/branch";
import abbottAndMixin from "@/mixins/liff/proj/abbott-and";
import SharedRadio from "@/components/DynamicForm/Radio.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [branchMixin, abbottAndMixin],
  components: {
    SharedButton,
    SharedRadio,
    MemberButton
  },
  data() {
    return {
      showLoading: false,
      options: [{ text: "特選藥局", value: "特選藥局" }],
      channel: null
    };
  },

  computed: {
    ...mapGetters({
      isBindStoreMember: "projAbbottAnd/isBindStore",
    }),
  },
  mounted() {
    console.log("[AND StorePicker] ========== StorePicker.vue mounted() ==========");
    console.log("[AND StorePicker] isBindStoreMember:", this.isBindStoreMember);
    this.checkAndMember();

    if(!this.isBindStoreMember) {
      console.log("[AND StorePicker] Adding additional channel options");
      this.options.push({ text: "亞培官方旗艦店", value: "AbbottMall" });
      this.options.push({
        text: "MOMO亞培品牌旗艦館",
        value: "MOMO",
      });
    }
    console.log("[AND StorePicker] Available options:", this.options);
  },

  methods: {
    ...mapActions('projAbbottAnd', ['setThanksMessage']),
    async bindStore() {
      console.log("[AND StorePicker] bindStore() called");
      console.log("[AND StorePicker] Selected channel:", this.channel);

      try {
        this.showLoading = true;
        console.log("[AND StorePicker] Calling joinChannel...");
        await this.joinChannel(this.channel);

        if (this.channel == "特選藥局") {
          console.log("[AND StorePicker] Channel is 特選藥局, redirecting to SendCoupon, couponType:", this.couponType);
          this.$router.push({
            name: "LiffProjAbbottAndSendCoupon",
            params: { couponType: this.couponType || 'j5' },
          });
          return;
        }
        console.log("[AND StorePicker] Other channel selected, redirecting to Welcome");
        this.setThanksMessage(`綁定成功 ${this.channel}`);
        this.$router.push({
          name: "LiffProjAbbottAndWelcome",
        });
        this.showLoading = false;
      } catch (error) {
        console.error("[AND StorePicker] Error:", error);
        this.setThanksMessage(error.response.data.message);
        this.$router.push({
          name: "LiffProjAbbottAndThanks",
        });
        this.showLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  &__input {
    background: #ffffff;
    border-radius: 10px !important;
    border: 1px solid var(--liff-button-color);
    padding: 15px 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;

    &::placeholder {
      letter-spacing: -0.408px;
      color: #b7b7b7;
    }

    &:focus {
      border: 1px solid var(--liff-button-color);
      outline: none;
    }
  }
}
</style>
